export const SUMMARY = '/api/v1/summary/latest';
